<div class="search-categories">
  <div class="search-categories__tabs">
    @if (showBackButtonInline()) {
      @if (currentPage() === SearchWidgetFiltersPageEnum.CARE_SERVICE_UNITS) {
        <button
          (click)="navigateBack()"
          aria-label="Tillbaka"
          class="icon-button navigate_back"
          type="button"
        >
          <app-ui-icon color="var(--grey-5)" name="chevron_back" size="md"></app-ui-icon>
        </button>
      }
    }

    <div class="tabs-container min-h-12 w-full min-w-full max-w-full">
      <nav (selectFocusedIndex)="onTabChange($event)" [tabPanel]="tabPanel" mat-tab-nav-bar>
        @for (link of tabs(); track link.name; let i = $index) {
          <a mat-tab-link
             (click)="cpruTabsService.handleTabsIndexChange(link.name)"
             [active]="highlightedSection() === link.name">
            <app-ui-icon color="var(--grey-0)" [name]="link.icon" size="md" *ngIf="link.icon"
                         class="hidden sm:inline-flex mr-2"></app-ui-icon>
            {{ link.label }}
            <div class="ml-1 opacity-50 inline-block text-xs sm:text-base" *ngIf="link.count">
              ({{ link.count }})
            </div>
          </a>
        }
      </nav>
      <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    </div>
  </div>

  <div class="search-categories__body">
    <div class="search-categories__inner h-full">
      <div class="search-categories__filters h-full">

        @if (currentPage() === SearchWidgetFiltersPageEnum.CARE_SERVICE_UNIT_GROUPS) {
          <div class="search-categories__menu-level-1 h-full">
            @if (isLoading()) {
              <div class="flex justify-center items-center p-4 h-full">
                <div class="spinner"></div>
              </div>
            } @else {
              <div
                class="search-categories__menu-level-1__list h-full">
                @for (group of careServiceUnitGroups(); let i = $index; track group.key) {
                  <div
                    (click)="selectCareServiceUnitGroup(i)"
                    class="search-categories__menu-level-1__list-item">
                    <div
                      class="search-categories__menu-level-1__list-item__label body-2 regular test-mega-menu-menu-level-1-item">
                      <app-area-icon [area]="group.key"></app-area-icon>
                      <span>{{ group.key }}</span>
                    </div>
                    <app-ui-icon
                      color="var(--green-2)"
                      name="chevron_right"
                      size="sm"
                    ></app-ui-icon>
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (currentPage() === SearchWidgetFiltersPageEnum.CARE_SERVICE_TYPE_GROUPS) {
          <div class="search-categories__menu-level-2 h-full">
            @if (isLoading()) {
              <div class="flex justify-center items-center p-4 h-full">
                <div class="spinner"></div>
              </div>
            } @else {
              <div
                class="search-categories__menu-level-2__list h-full">
                @for (type of careServiceTypes(); let i = $index; track type.id) {
                  <div class="search-categories__menu-level-2__list-item">
                    <a
                      (click)="onCareServiceTypeClick(type.routerLink, type.queryParams)"
                      [queryParams]="type.queryParams"
                      [rel]="type.noFollow ? 'nofollow' : ''"
                      [routerLink]="type.routerLink"
                      class="search-categories__menu-level-2__list-item__label body-2 regular test-mega-menu-menu-level-2-item"
                    >
                      {{ type.name }}
                    </a>
                  </div>
                }
              </div>
            }
          </div>
        }


        @if (currentPage() === SearchWidgetFiltersPageEnum.SYMPTOMS_GROUPS) {
          <div class="search-categories__menu-level-2 h-full">
            @if (isLoading()) {
              <div class="flex justify-center items-center p-4 h-full">
                <div class="spinner"></div>
              </div>
            } @else {
              <div
                class="search-categories__menu-level-2__list h-full">
                @for (symptom of symptoms(); let i = $index; track symptom.id) {
                  <div class="search-categories__menu-level-2__list-item">
                    <a
                      (click)="onSymptomClick(symptom.routerLink, symptom.queryParams)"
                      [queryParams]="symptom.queryParams"
                      [rel]="symptom.noFollow ? 'nofollow' : ''"
                      [routerLink]="symptom.routerLink"
                      class="search-categories__menu-level-2__list-item__label body-2 regular test-mega-menu-menu-level-2-item"
                    >
                      {{ symptom.name }}
                    </a>
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (currentPage() === SearchWidgetFiltersPageEnum.CARE_SERVICE_UNITS) {
          <div class="search-categories__menu-level-2 h-full">
            @if (isLoading()) {
              <div class="flex justify-center items-center p-4 h-full">
                <div class="spinner"></div>
              </div>
            } @else {
              <div
                class="search-categories__menu-level-2__list h-full">
                @for (unit of careServiceUnits(); let i = $index; track unit.id) {
                  <div class="search-categories__menu-level-2__list-item">
                    <a
                      (click)="onCareServiceUnitClick(unit.routerLink, unit.queryParams)"
                      [queryParams]="unit.queryParams"
                      [rel]="unit.noFollow ? 'nofollow' : ''"
                      [routerLink]="unit.routerLink"
                      class="search-categories__menu-level-2__list-item__label body-2 regular test-mega-menu-menu-level-2-item"
                    >
                      {{ unit.name }}
                    </a>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

